import send from "../../util/request";

export function getOrderPlanTask(params = {}) {
  return send({ url: '/ipp/order-plan-task/select', method: 'GET', params, options: { loading: true } });
}

export function modifyOrderPlanTask(params = {}) {
  return send({ url: '/ipp/order-plan-task/submit-modify', method: 'POST', data: params });
}
